/**
 * TSURATSURA Dawn Base Theme v3.1
 * ts-image-zoom.js — 商品画像ズーム
 * マウスホバーで拡大表示。モバイルではピンチズーム。lens方式。
 */

class TSImageZoom {
  constructor() {
    this.zoomFactor = 2.5;
    this.init();
  }

  init() {
    const containers = document.querySelectorAll('.ts-image-zoom');
    containers.forEach((container) => this.setup(container));
  }

  setup(container) {
    const img = container.querySelector('.ts-image-zoom__img');
    if (!img) return;

    const factor = parseFloat(container.getAttribute('data-ts-zoom-factor') || String(this.zoomFactor));
    let lens = container.querySelector('.ts-image-zoom__lens');

    if (!lens) {
      lens = document.createElement('div');
      lens.className = 'ts-image-zoom__lens';
      container.appendChild(lens);
    }

    if (this.isMobile()) {
      this.setupPinchZoom(container, img);
      return;
    }

    container.addEventListener('mouseenter', () => {
      const rect = img.getBoundingClientRect();
      lens.style.backgroundImage = `url(${img.src})`;
      lens.style.backgroundSize = `${rect.width * factor}px ${rect.height * factor}px`;
      container.classList.add('ts-image-zoom--active');
    });

    container.addEventListener('mousemove', (e) => {
      const rect = container.getBoundingClientRect();
      const x = e.clientX - rect.left;
      const y = e.clientY - rect.top;
      const lensW = lens.offsetWidth / 2;
      const lensH = lens.offsetHeight / 2;

      lens.style.left = `${x - lensW}px`;
      lens.style.top = `${y - lensH}px`;

      const bgX = (x / rect.width) * 100;
      const bgY = (y / rect.height) * 100;
      lens.style.backgroundPosition = `${bgX}% ${bgY}%`;
    });

    container.addEventListener('mouseleave', () => {
      container.classList.remove('ts-image-zoom--active');
    });
  }

  setupPinchZoom(container, img) {
    let initialDistance = 0;
    let currentScale = 1;
    let startScale = 1;

    container.addEventListener('touchstart', (e) => {
      if (e.touches.length === 2) {
        e.preventDefault();
        initialDistance = this.getDistance(e.touches[0], e.touches[1]);
        startScale = currentScale;
      }
    }, { passive: false });

    container.addEventListener('touchmove', (e) => {
      if (e.touches.length === 2) {
        e.preventDefault();
        if (initialDistance === 0) return;
        const distance = this.getDistance(e.touches[0], e.touches[1]);
        currentScale = Math.max(1, Math.min(startScale * (distance / initialDistance), 4));
        img.style.transform = `scale(${currentScale})`;
      }
    }, { passive: false });

    container.addEventListener('touchend', () => {
      if (currentScale <= 1.1) {
        currentScale = 1;
        img.style.transform = 'scale(1)';
      }
    });
  }

  getDistance(touch1, touch2) {
    const dx = touch1.clientX - touch2.clientX;
    const dy = touch1.clientY - touch2.clientY;
    return Math.sqrt(dx * dx + dy * dy);
  }

  isMobile() {
    return 'ontouchstart' in window && window.innerWidth < 750;
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new TSImageZoom();
});
